export default {
    init() {
        (function ($) {
            function setupAccordion() {
                var accordions = $('[data-accordion]');

                accordions.each(function (key, raccordion) {
                    var accordion = $(raccordion);
                    var items = accordion.find('> li');

                    if (typeof accordion.data('accordion-controls') !== 'undefined') {
                        var controls_div = $('<div />').attr('data-accordion-controls-container', '');
                        var expand_all = $('<a href="#" />').html('Expand All').attr('data-accordion-expand', '').click(function (e) {
                            e.preventDefault();
                            items.each(function (key, relem) {
                                $(relem).find('button:not(.active)').click();
                            });
                        });
                        var contract_all = $('<a href="#" />').html('Contract All').attr('data-accordion-contract', '').click(function (e) {
                            e.preventDefault();
                            items.each(function (key, relem) {
                                $(relem).find('button.active').click();
                            });
                        });

                        controls_div.append(expand_all).append(contract_all);
                        accordion.before(controls_div);
                    }

                    items.each(function (key, relem) {
                        var elem = $(relem);
                        var headButton = elem.find('> button');

                        var aiArrow = $('<span />').addClass('ai-arrow');
                        var iconHolder = $('<span />').addClass('icon-holder');
                        var svgLink = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                        var useLink = document.createElementNS('http://www.w3.org/2000/svg', 'use');
                        useLink.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#up-arrow');

                        svgLink.appendChild(useLink);
                        iconHolder.append(svgLink);
                        aiArrow.append(iconHolder);
                        headButton.prepend(aiArrow);

                        if (accordion.data('open') !== undefined) {
                            elem.find('> button').addClass('active');
                            elem.find('> section').show();
                        } else {
                            elem.find('> section').hide();
                        }
                        headButton.click(toggleAccordion);
                    });
                });
            }

            function toggleAccordion(e) {
                e.preventDefault();
                var button = $(this);
                var item = button.closest("li");
                var content = item.find("> section").first();
                if (content.is(":visible")) {
                    content.slideUp();
                    button.removeClass("active");
                    button.attr('aria-expanded', 'false');
                } else {
                    content.slideDown();
                    button.addClass("active");
                    button.attr('aria-expanded', 'true');
                }
            }

            function collapseAll(e) {
                e.preventDefault();
                var items = $('[data-accordion] button.active');
                items.click();
            }

            $(document).ready(setupAccordion);
            $(document).ready(function () {
                $('#collapse').click(collapseAll);
            });
        })(jQuery);
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateFaqs.js